import Vue from "vue";
import Router from "vue-router";
import AppHeaderWeb from "./layout/AppHeaderWeb";
import AppHeaderLogin from "./layout/AppHeaderLogin";
import AppHeaderMobile from "./layout/AppHeaderMobile";
import AppFooter from "./layout/AppFooter";
import Login from './views/Login/login'
import Deposit from './views/Deposit/deposit'
import Balance from './views/Balance/balance'
import Users from "./views/Users/users";
import WhatsApp from "./views/Whatsapp/whatsapp";
import PasswordReset from "./views/PasswordReset/passwordreset";
import MakeCommission from "./views/MakeCommission/makecommission";
import UnApproved from "./views/UnApproved/unapproved";
import Approved from "./views/Approved/approved";
import Rejected from "./views/Rejected/rejected";
import Callback from './views/Callback';
import CustomerSms from './views/Customersms/customersms';
import CustomerOveralTransactions from "./views/Reports/CustomerOveralTransactions/customeroveraltransactions"
import CustomerTransactions from "./views/Reports/CustomerTransactionsStatus/customertransactions"
import WalletReport from "./views/Reports/WalletReport/walletreport"
import metrics from "./views/Reports/Metrics/metrics"
import WalletCommissionReport from "./views/Reports/WalletCommissionReport/walletcommissionreport"
import ReferralCommissionReport from "./views/Reports/ReferralCommissionReport/ReferralCommissionReport"
import ProductReport from "./views/Reports/ProductReport/productreport"
import AgentMonthlySales from "./views/Reports/AgentMonthlySales/agentmonthlysales"
import UsersReport from "./views/Reports/UsersReport/UsersReport"
import UserState from "./views/UserState/UserState"
import AgentProductReport from "./views/Reports/AgentProductReport/AgentProductReport"
import AgentGrowthReport from "./views/Reports/AgentGrowthReport/AgentGrowthReport"
import StockOrders from "./views/Reports/StockOrders/stockorders"
import RelayedSms from "./views/RelayedSms/relayedsms"
import RelayedDeposits from "./views/RelayedDeposits/relayeddeposits"
import GeneralSettings from "./views/GeneralSettings/generalsettings"
import StockOrderAccess from "./views/Reports/StockOrderAccess/stockorderaccess"
import PayReferralCommission from "./views/PayReferralCommission/PayReferralCommission"
import UserDetails from "./views/UserDetails/UserDetails"
import { userAuth } from './services/security'
import { Plugins } from '@capacitor/core';

const { App } = Plugins;

import config from "@/settings/config.js"
import Taura from "./views/Taura/taura";


Vue.use(Router);

var header = AppHeaderWeb;
if (config.isMobile)
    header = AppHeaderMobile;

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'home',
        components: {
            header: AppHeaderLogin,
            default: Login,
            footer: AppFooter
        },
    },
    {
        path: "/login",
        name: "login",
        components: {
            header: AppHeaderLogin,
            default: Login,
            footer: AppFooter
        }
    },
    {
        path: "/landing",
        name: "landing",
        components: {
            header: AppHeaderLogin,
            default: Login,
            footer: AppFooter
        },
    },
    {
        path: '/callback',
        name: 'callback',
        components: {
            header: header,
            default: Callback
        }
    },
    {
        path: "/approved",
        name: "approved",
        components: {
            header: header,
            default: Approved,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/customersms",
        name: "customersms",
        components: {
            header: header,
            default: CustomerSms,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/rejected",
        name: "rejected",
        components: {
            header: header,
            default: Rejected,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/unapproved",
        name: "unapproved",
        components: {
            header: header,
            default: UnApproved,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/taura",
        name: "taura",
        components: {
            header: header,
            default: Taura,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/deposit",
        name: "deposit",
        components: {
            header: header,
            default: Deposit,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/userDetails",
        name: "userDetails",
        components: {
            header: header,
            default: UserDetails,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/balance",
        name: "balance",
        components: {
            header: header,
            default: Balance,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/generalsettings",
        name: "generalsettings",
        components: {
            header: header,
            default: GeneralSettings,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/whatsapp",
        name: "whatsapp",
        components: {
            header: header,
            default: WhatsApp,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/passwordreset",
        name: "passwordreset",
        components: {
            header: header,
            default: PasswordReset,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/makecommission",
        name: "makecommission",
        components: {
            header: header,
            default: MakeCommission,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/users",
        name: "users",
        components: {
            header: header,
            default: Users,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/customeroveraltransactions",
        name: "customeroveraltransactions",
        components: {
            header: header,
            default: CustomerOveralTransactions,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/walletreport",
        name: "walletreport",
        components: {
            header: header,
            default: WalletReport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/metrics",
        name: "metrics",
        components: {
            header: header,
            default: metrics,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/walletcommissionreport",
        name: "walletcommissionreport",
        components: {
            header: header,
            default: WalletCommissionReport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/referralCommissionReport",
        name: "referralCommissionReport",
        components: {
            header: header,
            default: ReferralCommissionReport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/payReferralCommission",
        name: "payReferralCommission",
        components: {
            header: header,
            default: PayReferralCommission,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/customertransactions",
        name: "customertransactions",
        components: {
            header: header,
            default: CustomerTransactions,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/stockorders",
        name: "stockorders",
        components: {
            header: header,
            default: StockOrders,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/relayedsms",
        name: "relayedsms",
        components: {
            header: header,
            default: RelayedSms,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/relayeddeposits",
        name: "relayeddeposits",
        components: {
            header: header,
            default: RelayedDeposits,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/stockorderaccess",
        name: "stockorderaccess",
        components: {
            header: header,
            default: StockOrderAccess,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/productreport",
        name: "productreport",
        components: {
            header: header,
            default: ProductReport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/agentmonthlysales",
        name: "agentmonthlysales",
        components: {
            header: header,
            default: AgentMonthlySales,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/usersreport",
        name: "usersreport",
        components: {
            header: header,
            default: UsersReport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/userstate",
        name: "userstate",
        components: {
            header: header,
            default: UserState,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/agentproductreport",
        name: "agentproductreport",
        components: {
            header: header,
            default: AgentProductReport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/agentgrowthreport",
        name: "agentgrowthreport",
        components: {
            header: header,
            default: AgentGrowthReport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    }
    ]
})

export default router;

App.addListener('appUrlOpen', function (data) {
    const slug = data.url.split('/').pop();
    router.push({
        path: '/' + slug,
    });
});

router.beforeEach(async (to, from, next) => {
    let app = userAuth.data().user || { isAuthenticated: false }
    const role = userAuth.getAuthorised();
    let hasRole = false;
    if (role) {
        if (Array.isArray(role))
            hasRole = role.includes("Operator");
        else
            hasRole = role === "Operator";
    }
    if (app.isAuthenticated && hasRole) {
        next()
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        await userAuth.SignOut();
        next();
    } else {
        //No auth required. We can navigate
        next()
    }
});